import { values } from "underscore";
import axiosInstance from "../utils/axios";

export const GetListOfCourses = async (data) => {
  return await axiosInstance().post("/getCourseSubjectList", data);
};

export const CopyCourses = async (data) => {
  return await axiosInstance().post("/copyCourses", data);
};

export const uploadTOS3BucketUrl = async (values) => {
  return await axiosInstance().post(`/uploadTOS3BucketUrl`, values);
};

export const getBookedCoursesList = async (data) => {
  return await axiosInstance().post("/getBookedCoursesList", data);
};

export const updateAdditionalFeedBack = async (data) => {
  return await axiosInstance().post("/uploadFeedbackFiles", data);
};
export const deleteFeedbackFiles = async (data) => {
  return await axiosInstance().post("/deleteFeedbackFiles", data);
};

export const getNetsuiteRooms = async () => {
  return await axiosInstance().get("/getNetsuiteRooms");
};

export const getBookedCoursesListCancelToken = async (data, cancelToken) => {
  return await axiosInstance().post("/getBookedCoursesList", {data: data}, {cancelToken: cancelToken});
};

export const GetOnlineClassGraphData = async (id, classId = null) => {
  const params = new URLSearchParams({ uid: id });

  if (classId) {
    params.append("class_id", classId);
  }

  return await axiosInstance().get(`/intakes-list-statistics?${params.toString()}`);
};

export const GetOnlineClassGraphDataCancelToken = async (id, cancelToken, classId = null) => {
  const params = new URLSearchParams({ uid: id });

  if (classId) {
    params.append("class_id", classId);
  }

  return await axiosInstance().get(`/intakes-list-statistics?${params.toString()}`, {
    cancelToken: cancelToken,
  });
};

export const UpdateClassRecordStatus = async (id, status) => {
  return await axiosInstance().get("/toggleRecording?meetingId=" + id + "&action=" + status);
};
export const updateBookedCourseDetails = async (data) => {
  return await axiosInstance().post("/updateBookedCourseDetails", {data: data});
};
export const updateCourseExemption = async (data) => {
  return await axiosInstance().post("/updateCourseExemption", data);
};

export const GetNotificationsList = async (id) => {
  return await axiosInstance().get(`/getProgramsNotificationList?intake=${id}&type=course_notification`);
};

export const GetCourseDetails = async (id) => {
  return await axiosInstance().get("/intakes-list-edit?uid=" + id);
};

export const GetCourseDetailsCancelToken = async (id, cancelToken) => {
  return await axiosInstance().get("/intakes-list-edit?uid=" + id, {cancelToken});
};

export const GetList = async () => {
  return await axiosInstance().get("/intakes-list-edit");
};

export const GetListCancelToken = async (cancelToken) => {
  return await axiosInstance().get("/intakes-list-edit", { cancelToken });
};

export const GetOnlineClassesData = async (data) => {
  return await axiosInstance().get(`/getOnlineClassesData?class_id=${data.class_id}&intake=${data.intake}&isRecurring=${data.isRecurring}`);
};

export const GetListOfAssemblies = async (data) => {
  return await axiosInstance().post("/getAssembliesList",data);
};

export const GetListOfAssembliesCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getAssembliesList`, values, {
    cancelToken: cancelToken
  });
};

export const GetListOfLinkedAssembliesCancelToken = async (quizId, cancelToken) => {
  return await axiosInstance().get(`/getQuizAssignedAssemblies?quiz_id=${quizId}`, {cancelToken: cancelToken});
};

export const GetListOfAssembliesFilters = async () => {
  return await axiosInstance().get("/getAssembliesCommonContent");
};

export const GetListOfAssembliesFiltersCancelToken = async (cancelToken) => {
  return await axiosInstance().get("/getAssembliesCommonContent", {cancelToken: cancelToken});
};

export const GetDetailOfAssembliesCancelToken = async (id, cancelToken) => {
  return await axiosInstance().get("/getAssembliesDetail", { params: { id } , cancelToken: cancelToken });
};
export const getAssemblyDynamicFilters = async (cancelToken) => {
  return await axiosInstance().get("/getAssemblyDynamicFilters", { cancelToken: cancelToken });
};

export const AddAssemblies = async (values) => {
  return await axiosInstance().post("/addAssemblies", values);
};

export const AddAssembliesResources = async (values) => {
  return await axiosInstance().post("/addAssembliesResource", values);
};

export const DeleteAssemblies = async (id) => {
  return await axiosInstance().post("/deleteAssemblies", id);
};

export const AddAndUpdateAssembliesItems = async (data) =>{
  return await axiosInstance().post("/addAndUpdateAssembliesItems",data);
}

export const GetAssembliesLists = async (id) =>{
  return await axiosInstance().get("/getAssembliesLists?id_assembly="+id);
}

export const GetAssembliesListsCancelToken = async (id, cancelToken) =>{
  return await axiosInstance().get("/getAssembliesLists?id_assembly="+id, {cancelToken: cancelToken});
}

export const GetAvailableAssemblies = async (id) => {
  return await axiosInstance().post("/getAssembliesListData", id);
};

export const GetAssignedAssemblies = async (id,data) => {
  return await axiosInstance().get("/getAssignedAssemblies?id_subject=" + id + "&dynamicFilter=" + data);
}

export const DeleteAssignedAssemblies = async (id) => {
  return await axiosInstance().post("/deleteAssignedAssemblies?ref_id=" + id);
}

export const DeleteNotifications = async (values) => {
  return await axiosInstance().post("/delete_notification", values);
}

export const AssignAssembly = async (id, aId) => {
  return await axiosInstance().post("/assignAssemblies?id_subject=" + id + "&id_assembly=" + aId);
}

export const AssignAssemblyCourses = async (subjectIds, assemblyId) => {
  return await axiosInstance().post("/assignAssemblieCourses", {
    subjectIds,
    assemblyId,
  });
}

export const GetStudentList = async (id,data) => {
  return await axiosInstance().get("/get-studen-list?intake=" + id + "&dynamicFilter=" + data);
}

export const GetAssessmentListCancelToken = async (id = null,data, quizId = null, cancelToken) => {
  let param = id !== null ? "?uid=" + id + "&dynamicFilter=" + data : ""
  if(quizId){
    param = "?quiz_id=" + quizId + "&dynamicFilter=" + data;
  }
  return await axiosInstance().get("/get-assesments-list-data" + param, {cancelToken} );
}

export const GetListOfResources = async (values = {}) => {
  return await axiosInstance().get("/getAssembliesItemsList", { params: values });
};

export const GetListOfItemsResources = async (values) => {
  return await axiosInstance().get(`/getAssembliesItemsList?parent_id=${values}`);
};

export const GetListOfAssignedResourcesCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post("/getAssignedResources", values, {cancelToken: cancelToken});
};

export const GetListOfAvailableResourcesCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post("/getAvailableResources", values, {cancelToken: cancelToken});
};

export const AddCourse = async (data) => {
  return await axiosInstance().post("/add-new-subject/", data);
}

export const GetAssemblyResourceDetail = async (values) => {
  return await axiosInstance().post("/getAssemblyResourceDetail", values);
};

export const GetAssemblyResourceDetailCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post("/getAssemblyResourceDetail", values, {cancelToken: cancelToken});
};

export const EditAssemblyResourceDetail = async (values) => {
  return await axiosInstance().post("/editAssembliesItem", values);
};

export const EditAssemblies = async (values) => {
  return await axiosInstance().post("/editAssemblies", values);
};

export const AddAssignedAssemblyResource = async (values) => {
  return await axiosInstance().post("/addAssignedAssemblyResource", values);
};

export const DeleteAssemblyResource = async (values) => {
  return await axiosInstance().post("/deleteAssemblyItem", values);
};

export const GetLinkedCoursesCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post("/getLinkedCourses", values, {cancelToken: cancelToken});
};

export const AddOnlineClass = async (data) => {
  return await axiosInstance().post("/createNewOnlineClasses", data);
}

export const EditOnlineClass = async (data) => {
  return await axiosInstance().post("/updateOnlineClasses", data);
}

export const GetClassRecordings = async (id) => {
  return await axiosInstance().get("getClassRecordingList?intake=" + id);
}

export const UploadClassRec = async (data) => {
  return await axiosInstance().post("/uploadClassRecording/", data);
}

export const GetClassTypeOptionList = async (id) => {
  return await axiosInstance().get("classTypeOptionList");
}

export const GetAssessmentSubmissionResults = async (id, intake) => {
  return await axiosInstance().get(`getAssessmentSubmissionResults`, {params: {assessment_id: id, intake_id: intake}});
}

export const SendQuickNotification = async (data) => {
  return await axiosInstance().post("/sendQuickNotification/", data);
}

export const DeleteOnlineClass = async (data) => {
  return await axiosInstance().post("/b_remove_online_class/", data);
}


export const UpdateSubmission = async (data) => {
  return await axiosInstance().post("update_assessment_submission_upload", data);
}

export const GetAssessmentSubmissionUpload = async (data) => {
  return await axiosInstance().post("get_assessment_submission_upload", data);
}

export const AddAndGetTicketComment = async (data) => {
  return await axiosInstance().post("addAndGetTicketComment", data);
}

export const ResetTotalMark = async (data) => {
  return await axiosInstance().post("resetTotalMark", data);
}

export const resetSubmissionTotalMark = async (data) => {
  return await axiosInstance().post("resetSubmissionTotalMark", data);
}

export const GetCrmProductListCancelToken = async (cancelToken) => {
  return await axiosInstance().get(`crmProducts`, { cancelToken });
}

export const DeleteAssessmentSubmissionUpload = async (data) => {
  return await axiosInstance().post("delete_assessment_submission_upload", data);
}

export const UploadMarkAssessment = async (data) => {
  return await axiosInstance().post("upload_attachment", data);
}

export const LaunchVirtualClass = async (data, isStart = true) => {
  return await axiosInstance().post(isStart ? "moderatorRedirect" : "endmeeting", data)
}

export const GetLuanchButtonData = async (data) => {
  return await axiosInstance().post("getLaunchButtonData", data);
}

export const DeleteAssignedAssemblyResource = async (values) => {
  return await axiosInstance().post("/deleteAssignedResource", values);
};

export const GetAssignedAssembliesToResource = async (values) => {
  return await axiosInstance().get("/getAssignedAssembliesToResource?item_id=" + values);
};

export const GetAssemblyResourceAuditTrailCancelToken = async (param,cancelToken) => {
  return await axiosInstance().get(`/getAssemblyResourceAuditTrail`, { params:param, cancelToken: cancelToken });
};

export const GetAssemblyResourceAuditTrailDropdownCancelToken = async (param, cancelToken) => {
  return await axiosInstance().get(`/getAssemblyResourceAuditTrailDropdown`, { params: param, cancelToken: cancelToken });
};

export const GetNetsuiteProductListCancelToken = async (serviceType = "Service", cancelToken) => {
  return await axiosInstance().get("/getNetsuiteProductList?itemtype=" + serviceType, { cancelToken });
}

export const CreateNotification = async (params) => {
  return await axiosInstance().post("/addSubjectNotification", params);
}

export const GetNotificationDetails = async (params) => {
  return await axiosInstance().get(`/getProgramsNotificationDetails?id=${params.id}?type=${params.type}`)
}

export const JoinClassAsAdmin = async (params) => {
  return await axiosInstance().post("/joinAsGuest", params);
}

export const GetClassParticipants = async (id) => {
  return await axiosInstance().get(`studentClassReport?class_id=${id}`);
}

export const GetStudentAttaendance = async (id) => {
  return await axiosInstance().get(`/studentsAttendanceClassSummary?class_id=${id}`);
}

export const AddTimer = async (data) => {
  return await axiosInstance().post(`/studentAddManualAttendance`, data);
};

export const GetCommonContent = async () => {
  return await axiosInstance().get(`/getCommonContent`)
}

export const GetSelectClass = async () => {
  return await axiosInstance().get(`/getOnlineClassesSelectList`)
}

export const GetSelectClassFilter = async () => {
  return await axiosInstance().get(`/getOnlineClassesSelectListFilters`)
}

export const AddSelectClass = async (data) => {
  return await axiosInstance().post("/onlineSelectClasses", data);
}

export const AddOrUpdateStudentNote = async (values) => {
  return await axiosInstance().post(`/addOrUpdateStudentNote`, values);
};

export const OnCampusCheckOutIn = async (data) => {
  return await axiosInstance().post("/onCampusCheckOutIn", data);
}

export const classLaunch = async (data) => {
  return await axiosInstance().post("/classLaunch", data);
}

export const DownloadAssessmentsStudentResults = async (param) => {
  return await axiosInstance().get('/downloadAssementsStudentResults', {params:param})
}

export const GetMarkasCompelete = async (data) => {
  return await axiosInstance().post('/markAsComplete', data)
}

export const GetimportMarks = async (file) => {
  return await axiosInstance().post('/importMarks', file)
}

export const getAve = async () => {
  return await axiosInstance().get("/durationCalculation");
};

export const GetAssessmentDropdown = async () => {
  return await axiosInstance().get("/getAssessmentlistDropdown");
}

export const GetAvailableCourselist = async (data) => {
  return await axiosInstance().post('/getAvailableCourselist', data)
}
export const GetQuiz = async (data) => {
  return await axiosInstance().post("/getQuiz",data);
};
export const GetQuestionsByQuiz = async (val) => {
  return await axiosInstance().get(`/getQuestionsByQuiz?quiz_id=${val}`)
}

export const GetModuleResourceAudit = async (data) => {
  return await axiosInstance().post(`/getModuleResourceAudit`, data);
};

export const getModuleResourceAuditFilters = async (values,cancelToken) => {
  return await axiosInstance().get(`/getModuleResourceAuditFilters`, { params: values, cancelToken: cancelToken });
};

export const CourseAssignedProgramme = async (data) => {
  return await axiosInstance().post(`/course_assigned_programme`, data);
};

export const SendAssignmentInstruction = async (data) => {
  return await axiosInstance().post(`/sendAssignmentInstuction`, data);
};

export const GetAvailableCourselistFilters = async () => {
  return await axiosInstance().get(`/getAvailableCourselistFilters`)
}

export const DeleteAssessment = async (data) => {
  return  await axiosInstance().post(`/delete-assessment`,data);
}
export const GetLoadBalancing = async () => {
  return await axiosInstance().get(`activeServerList`);
}


export const AssignAssemblies = async (values) => {
  return await axiosInstance().post("/assembliesRearrange", values);
};

export const readAllCommentMessages = async (values) => {
  return await axiosInstance().post("/readAllCommentMessages", values);
};


export const GradeLetterTemplateList = async (values) => {
  return await axiosInstance().get(`/getGradeLetterTemplateList`, {params: values});
};

export const UpcomingImportantDates = async (values) => {
  return await axiosInstance().get(`/upcomingImportantDates`, {params: values});
};

export const UpcomingImportantDatesCancelToken = async (values, cancelToken) => {
  return await axiosInstance().get(`/upcomingImportantDates`, {params: values, cancelToken: cancelToken});
};

export const onlineClassesStatistics = async (values) => {
  return await axiosInstance().get(`/onlineClassesStatistics`, {params: values});
};

export const onlineClassesStatisticsCancelToken = async (values, cancelToken) => {
  return await axiosInstance().get(`/onlineClassesStatistics`, {params: values, cancelToken: cancelToken});
};

export const getCourseClassAttend = async (values) => {
  return await axiosInstance().get(`/getCourseClassAttend`, {params: values});
};

export const getCourseClassAttendCancelToken = async (values, cancelToken) => {
  return await axiosInstance().get(`/getCourseClassAttend`, {params: values, cancelToken: cancelToken});
};

export const getCourseAvgRating = async (values) => {
  return await axiosInstance().get(`/getCourseAvgRating`, {params: values});
}

export const getCourseAvgRatingCancelToken = async (values, cancelToken) => {
  return await axiosInstance().get(`/getCourseAvgRating`, {params: values, cancelToken: cancelToken});
}

export const GetCourseAuditTrialCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getCourseAuditTrial`, values, {
    cancelToken: cancelToken
  });
};

export const getBookedCourseAuditFilters = async (values) => {
  return await axiosInstance().get(`/getBookedCourseAuditFilters`, {params: values});
};
export const getBookedCourseAuditTrail = async (values) => {
  return await axiosInstance().post(`/getBookedCourseAuditTrail`, values);
};

export const GetCourseAuditTrialDropdownCancelToken = async (values,cancelToken) => {
  return await axiosInstance().get(`/getCourseAuditTrialDropdown`, { params: values, cancelToken: cancelToken });
};

export const GetAssessemntAuditTrialCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getAssessementAuditTrial`, values, {
    cancelToken: cancelToken
  });
};

export const GetAssessmentAuditTrialDropdownCancelToken = async (values,cancelToken) => {
  return await axiosInstance().get(`/getAssessmentAuditTrialDropdown`, { params: values, cancelToken: cancelToken });
};
export const getSubmissionSummary = async (values) => {
  return await axiosInstance().get(`/getSubmissionSummary`, {params: values});
};

export const getSubmissionSummaryCancelToken = async (values, cancelToken) => {
  return await axiosInstance().get(`/getSubmissionSummary`, {params: values, cancelToken: cancelToken});
};

export const GetClassFiles = async (values) => {
  return await axiosInstance().get(`/getClassFiles`, { params: values });
};
 
export const getSupplementaryStdList = async (data) => {
  return await axiosInstance().post(`/getSupplementaryStdList`, data );
};

export const getSickAssessmentStudentList = async (data) => {
  return await axiosInstance().post(`/getSickAssessmentStudentList`, data );
};

export const getAssignedGrademixViaAssessment = async (values) => {
  return await axiosInstance().get(`/getAssignedGrademixViaAssessment`, {params: values});
};
export const removeClassRecording = async (values) => {
  return await axiosInstance().get(`/removeClassRecording`, { params: values });
};

export const updateGrademixMarkSubmission = async (data) => {
  return await axiosInstance().post(`/updateMarkSubmission`, data);
}

export const updateSubmissionMarks = async (data) => {
  return await axiosInstance().post(`/updateSubmissionMarks`, data);
}

export const getCourseGradeMixQulification = async (data) => {
  return await axiosInstance().post(`/getCourseGradeMixQulification`, data);
}
export const deleteGenerateCertificate = async (values) => {
  return await axiosInstance().post(`/deleteGenerateCertificate`, values);
};
export const GetNetsuiteItemsCancelToken = async (serviceType = "Service", cancelToken) => {
  return await axiosInstance().get(`/getNetsuiteItems?itemtype=${serviceType}`, { cancelToken });
}

export const GetMarkingAssessmentDetails = async (values , intake) => {
  return await axiosInstance().get(`/markingAssessmentDetails?assessment_id=${values}&intake=${intake}`);
};

export const GetMarkingAssessmentQuestions = async (values) => {
  return await axiosInstance().post(`/markingAssessmentQuestions`, values);
};

export const GetMarkingAssessmentQuestionsCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/markingAssessmentQuestions`, values, { cancelToken: cancelToken });
};

export const GetMarkingAssessmentQuestionsFilters = async (values, intake) => {
  return await axiosInstance().get(`/markingAssessmentQuestionsFilters?assessment_id=${values}&intake=${intake}`);
};

export const GetMarkingAssessmentAllQuestions = async (value, intake, cancelToken) => {
  return await axiosInstance().get(`/getMarkingAssessmentQuestionList?assessment_id=${value}&intake=${intake}`,{ cancelToken: cancelToken });
};
export const GetMarkingAssessmentQuestion = async (values,cancelToken) => {
  return await axiosInstance().get(`/getMarkingAssessmentQuestion?assessment_id=${values.assessmentId}&questionId=${values?.quesId}&intake=${values?.intake}`, cancelToken);
};
export const GetMarkingAssessmentStudentList = async (values,cancelToken) => {
  return await axiosInstance().post(`/assessmentMarkingStudentList`, values, cancelToken);
};
export const updateAssessmentScore = async (values,cancelToken) => {
  return await axiosInstance().post(`/updateAssessmentMarkingQuestionScore`, values, cancelToken);
};
export const updateObservation = async (values) => {
  return await axiosInstance().post(`/updateObservation`, values);
};
export const updateSubmissionData = async (values) => {
  return await axiosInstance().post(`/updateAssessmentMarkingQuestionScore`, values);
};
export const uploadEvidence = async (values, params) => {
  return await axiosInstance().post(`/uploadAssessmentEvidence`, values,params);
};
export const deleteEvidence = async (values) => {
  return await axiosInstance().post(`/removeAssessmentEvidence`, values);
};
export const approvedRejectEvidence = async (values) => {
  return await axiosInstance().post(`/approvedRejectEvidence`, values);
};
export const getUsersAnswers = async (values,cancelToken) => {
  return await axiosInstance().post(`/viewQuestion`, values,cancelToken);
};
export const GetStudentSubmissionDetails = async (id, stuId, intake, rid) => {
  const params = new URLSearchParams({
    assessment_id: id,
    student_id: stuId,
    intake: intake
  });

  if (rid) {
    params.append('rid', rid);
  }

  return await axiosInstance().get(`/studentSubmissionDetails?${params.toString()}`);
}

export const addUpdateFeedback = async (data) => {
  return await axiosInstance().post(`/addUpdateFeedback`, data);
}

export const addUpdateDeleteSignature = async (data) => {
  return await axiosInstance().post(`/addUpdateDeleteSignature`, data);
}

export const updateAssessmentMarkingQuestionScore = async (data) => {
  return await axiosInstance().post(`/updateAssessmentMarkingQuestionScore`, data);
}

export const generateFeedbackStudent = async (data) => {
  return await axiosInstance().post(`/generateFeedbackStudent`, data);
}

export const GetIntakeDetails = async (id) => {
  return await axiosInstance().get(`/getIntakeDetails?id=${id}`);
}
export const CopyAcademicAmi = async (data) => {
  return await axiosInstance().post("/copyAcademicAmiCourse", data);
};

export const GetAcademicCourseDetails = async (courseId) => {
  return await axiosInstance().get(`/getAcademicAmiCourseDetails/${courseId}`);
};

export const GetClassAttendanceAuditTrailCancelToken = async (values, cancelToken) => {
  return await axiosInstance().post(`/getClassAttendanceAuditTrail`, values, {
    cancelToken: cancelToken
  });
};

export const GetClassAttendanceAuditTrailDropdownCancelToken = async (values,cancelToken) => {
  return await axiosInstance().get(`/getClassAttendanceAuditTrailDropdown`, { 
    params: values, 
    cancelToken: cancelToken 
  });
};

export const recalculateClassAttendance = async (data) => {
 return await axiosInstance().post("/recalculateClassAttendance", data);
};

export const lockedProgrammes = async (values, cancelToken) => {
  return await axiosInstance().post(`/checkLockedProgrammes`, values, {
    cancelToken,
  });
};

// end